module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-content"
  }, [_c('div', {
    staticClass: "app-content-body banners"
  }, [_c('CHeader'), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11f4170f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/policia-civil/notificacao/situacao-aviso-recebimento/Main.vue
// module id = 1508
// module chunks = 17